import Blue from '~/core'

new Blue({
  name: 'ReadMore',
  selector: '.status-card--read-more',
  setup(readMore) {
    let trigger = readMore.querySelector('.status-card__trigger')
    let trigger2 = readMore.querySelector('.status-card__read-more-trigger')
    let content = readMore.querySelector('.status-card__content')

    trigger.addEventListener('click', toggleReadMore)
    trigger2.addEventListener('click', toggleReadMore)

    function toggleReadMore() {
      readMore.classList.toggle('is-active')
      if (readMore.classList.contains('is-active')) {
        trigger2.innerHTML = 'Read Less'
      } else {
        trigger2.innerHTML = 'Read More'
      }
    }
  },
})
